var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:_vm.className},[_c('ul',_vm._l((_vm.routes),function(route,index){return _c('li',{key:`routes-${index}`},[(index !== _vm.lastIndex)?_c('router-link',{attrs:{"to":route.path}},[_vm._v(_vm._s(route.name))]):_c('span',[_vm._v(_vm._s(route.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }